// Tiny code-drawn sprites: no extra images, timers, or media tracks.
const pixel=(ctx,x,y,w,h,color)=>{ctx.fillStyle=color;ctx.fillRect(x,y,w,h);};
function person(ctx,x,y,unit,time,artist,phase){
 const cycle=(time+phase)%18;
 const walking=cycle<12;
 const progress=walking?(cycle<6?cycle/6:2-cycle/6):0;
 const facing=cycle<6||!walking?1:-1;
 const stride=walking?Math.floor(time*9+phase)%2:0;
 ctx.save();
 ctx.translate(Math.round(x+progress*unit*22),Math.round(y));ctx.scale(unit*facing,unit);
 pixel(ctx,-5,0,12,2,'#18212a40');
 const bob=walking?stride:0;ctx.translate(0,-bob);
 pixel(ctx,-3,-8,3,6-stride*2,'#293149');pixel(ctx,2,-8,3,4+stride*2,'#293149');
 pixel(ctx,-4,-3+stride*2,4,2,'#171d2e');pixel(ctx,2,-1-stride*2,5,2,'#171d2e');
 pixel(ctx,-4,-16,9,9,artist?'#9878bc':'#395578');
 pixel(ctx,-2,-15,5,8,artist?'#e9d9bb':'#dbe5e8');
 if(artist){pixel(ctx,-1,-11,2,2,'#eb8198');pixel(ctx,2,-10,1,2,'#54b6ac');}
 else pixel(ctx,0,-15,2,6,'#d39b67');
 pixel(ctx,-3,-23,7,7,'#e9b48c');pixel(ctx,3,-20,2,2,'#e9b48c');pixel(ctx,2,-21,1,1,'#202638');
 pixel(ctx,-4,-24,8,3,artist?'#785496':'#4a3534');pixel(ctx,-4,-21,2,3,'#4a3534');
 if(artist){pixel(ctx,-5,-25,9,3,'#785496');pixel(ctx,-1,-27,2,2,'#4d345e');}
 pixel(ctx,-6,-15,2,7-stride,'#e9b48c');
 const hand=artist&&!walking?Math.floor(time*3)%2*2:0;
 pixel(ctx,4,-14-hand,4,2,'#e9b48c');
 if(artist){pixel(ctx,7,-19-hand,1,7,'#9e6743');pixel(ctx,7,-21-hand,2,3,'#60c9b8');}
 else {pixel(ctx,6,-17,4,4,'#fcf0d8');pixel(ctx,10,-16,1,2,'#fcf0d8');pixel(ctx,6,-18,4,1,'#634c40');}
 ctx.restore();
}
function business(ctx,x,y,u,t,phase){
 const step=Math.sin(t*9+phase),travel=(1-Math.cos(t*.55+phase))*12;
 ctx.save();ctx.translate(x+travel*u,y);ctx.scale(u,u);
 ctx.strokeStyle='#17243b';ctx.fillStyle='#17243b';ctx.lineWidth=1.6;ctx.lineCap='round';
 const line=(points)=>{ctx.beginPath();points.forEach(([a,b],i)=>i?ctx.lineTo(a,b):ctx.moveTo(a,b));ctx.stroke();};
 ctx.beginPath();ctx.arc(0,-23,3,0,Math.PI*2);ctx.fill();
 line([[0,-19],[0,-10],[-4-step*2,-1]]);line([[0,-10],[4+step*2,-1]]);
 line([[-5,-11],[0,-17],[5,-12]]);
 pixel(ctx,-2,-18,4,7,'#344e6d');pixel(ctx,0,-17,1,4,'#eec778');
 ctx.strokeRect(4,-11,3,2);pixel(ctx,2,-9,7,5,'#8a6441');
 ctx.restore();
}
function gardenLife(ctx,w,h,u,t){
 for(const [x,y,phase] of [[w*.1,h*.91,0],[w*.78,h*.84,5]]){
  const stride=Math.floor(t*6+phase)%2;
  ctx.save();ctx.translate(x+(1-Math.cos(t*.45+phase))*u*12,y);ctx.scale(u,u);
  pixel(ctx,-4,-4,3,4-stride,'#463c35');pixel(ctx,2,-4,3,3+stride,'#463c35');
  pixel(ctx,-5,-13,10,9,'#487d6a');pixel(ctx,-3,-20,7,7,'#eac3a0');
  pixel(ctx,-4,-16,8,5,'#eee7d5');pixel(ctx,-2,-11,4,3,'#eee7d5');pixel(ctx,2,-17,3,2,'#eac3a0');
  for(let row=0;row<9;row++)pixel(ctx,-Math.floor(row/2),-29+row,1+Math.floor(row/2)*2,1,'#bc4e57');
  pixel(ctx,5,-12-stride,3,2,'#eac3a0');pixel(ctx,7,-11-stride,5,5,'#789ba6');
  pixel(ctx,11,-9-stride,3,1,'#789ba6');
  for(let i=0;i<3;i++)pixel(ctx,14+i,-7+((t*8+i*3)%9),1,2,'#acdfea');
  ctx.restore();
 }
 for(const [x,y,phase,color] of [[w*.18,h*.42,0,'#e8b1ea'],[w*.8,h*.56,3,'#a1e8dd']]){
  ctx.save();ctx.translate(x+Math.sin(t*.8+phase)*u*18,y+Math.cos(t*1.1+phase)*u*12);ctx.scale(u,u);
  const wing=2+Math.abs(Math.sin(t*12+phase))*4;
  ctx.fillStyle='#e8f5ffbb';ctx.beginPath();ctx.ellipse(-wing/2,-2,wing,4,-.5,0,Math.PI*2);ctx.ellipse(wing/2,-2,wing,4,.5,0,Math.PI*2);ctx.fill();
  pixel(ctx,-1,-3,3,6,color);pixel(ctx,-1,-7,3,3,'#f4d2ac');pixel(ctx,-2,-8,4,2,'#dcc07d');
  pixel(ctx,3,0,4,1,'#f4d2ac');pixel(ctx,7,-3,1,5,'#e9d49c');
  pixel(ctx,6,-4,3,1,'#fff0b5');pixel(ctx,7,-5,1,3,'#fff0b5');
  for(let i=0;i<3;i++){ctx.globalAlpha=.25+.45*(.5+.5*Math.sin(t*3+i));pixel(ctx,-8-i*4,5+Math.sin(t+i)*3,1,1,'#fff2bd');}
  ctx.restore();
 }
}
export function drawBackgroundCharacters(ctx,id,w,h,time=0){
 if(!['office','art-studio','realistic-garden'].includes(id)||w<=0||h<=0)return;
 const t=(Number.isFinite(time)?Math.max(0,time):0)/1000;
 const unit=Math.max(.5,Math.min(w,h)/260);
 ctx.save();
 try{
  ctx.imageSmoothingEnabled=false;
  if(id==='realistic-garden'){gardenLife(ctx,w,h,unit,t);return;}
  if(id==='office'){business(ctx,w*.08,h*.9,unit,t,0);business(ctx,w*.78,h*.83,unit*.82,t,3);return;}
  const artist=id==='art-studio';
  // Viewport-relative paths keep characters visible on portrait camera crops.
  person(ctx,w*.08,h*.9,unit,t,artist,0);
  person(ctx,w*.78,h*.83,unit*.82,t,artist,7);
  if(artist){
   ctx.save();ctx.translate(Math.round(w*.08+unit*9),Math.round(h*.9));ctx.scale(unit,unit);
   pixel(ctx,0,-22,1,23,'#795138');pixel(ctx,9,-22,1,23,'#795138');
   pixel(ctx,-1,-22,12,15,'#a37b52');pixel(ctx,0,-21,10,13,'#f4e6ce');
   pixel(ctx,2,-17,5,4,'#8aafaa');pixel(ctx,5,-15,3,4,'#c29ab8');pixel(ctx,-2,-7,14,2,'#795138');ctx.restore();
  }
 }finally{ctx.restore();}
}
